import { inject } from "@angular/core";
import { type CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { USER_ROLES } from "../dashboard/dashboard.constants";
import { UserRole } from "../shared/types/user-role.type";

/**
 * Guard to prevent Read-only users from accessing edit/create routes.
 * Redirects to view mode if an ID is present, otherwise to dashboard.
 */
export const editAccessGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const user = authService.user()();

  if (!user) {
    // Should be handled by authGuard, but just in case
    return router.createUrlTree(["/login"]);
  }

  const role = user.role as UserRole;
  const canEdit = role === USER_ROLES.CONFIGURATOR || role === USER_ROLES.ADMIN;

  if (canEdit) {
    return true;
  }

  // If user cannot edit, redirect based on context
  const id = route.paramMap.get("id");

  if (id !== null && id !== "") {
    // If trying to edit an existing config, redirect to view mode
    return router.createUrlTree(["/configure", id]);
  }

  // If trying to create new (no ID), redirect to dashboard
  return router.createUrlTree(["/dashboard"]);
};
